import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

// const API_BASE = `http://${window.location.hostname}:8000`;
const API_BASE = process.env.REACT_APP_API_URL;
// const API_BASE = 'https://spradley-website.onrender.com';

export function useMD(collection, id) {
  return useQuery({
    queryKey: ["bio", collection, id],
    enabled: !!id,
    queryFn: async () => {
      const res = await fetch(`${API_BASE}/bios/${collection}/${id}`);
      if (!res.ok) throw new Error("Markdown not found");
      return res.text();
    },
  });
}

export function useSaveMD(collection) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, markdown }) => {
      const res = await fetch(`${API_BASE}/bios/${collection}/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ markdown }),
      });

      if (!res.ok) {
        const msg = await res.json();
        throw new Error(msg.detail || "Save failed");
      }

      return res.json();
    },
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(["bio", collection, id]);
    },
  });
}
